'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var key = require('interface-datastore/key');

var PQueue = require('p-queue');

var _get = require('just-safe-get');

var _set = require('just-safe-set');

var errCode = require('err-code');

var errors = require('./errors.js');

var toString = require('uint8arrays/to-string');

var fromString = require('uint8arrays/from-string');

var level = require('./utils/level.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var PQueue__default = /*#__PURE__*/_interopDefaultLegacy(PQueue);

var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);

var _set__default = /*#__PURE__*/_interopDefaultLegacy(_set);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var Queue = PQueue__default["default"].default ? PQueue__default["default"].default : PQueue__default["default"];
var configKey = new key.Key('config');

function config(store) {
  var setQueue = new Queue({
    concurrency: 1
  });
  var configStore = {
    getAll: function getAll() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options, encodedValue;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                _context.next = 3;
                return level.getWithFallback(configKey, store.get.bind(store), store.has.bind(store), store);

              case 3:
                encodedValue = _context.sent;
                return _context.abrupt("return", JSON.parse(toString.toString(encodedValue)));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    get: function get(key) {
      var _arguments2 = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var options, config, value;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {};

                if (!(key == null)) {
                  _context2.next = 3;
                  break;
                }

                throw new errors.NotFoundError("Key ".concat(key, " does not exist in config"));

              case 3:
                _context2.next = 5;
                return _this.getAll(options);

              case 5:
                config = _context2.sent;
                value = _get__default["default"](config, key);

                if (!(value === undefined)) {
                  _context2.next = 9;
                  break;
                }

                throw new errors.NotFoundError("Key ".concat(key, " does not exist in config"));

              case 9:
                return _context2.abrupt("return", value);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    set: function set(key, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof key !== 'string' && !(key instanceof String)) {
        throw errCode__default["default"](new Error('Invalid key type: ' + typeof key), 'ERR_INVALID_KEY');
      }

      if (value === undefined || value instanceof Uint8Array) {
        throw errCode__default["default"](new Error('Invalid value type: ' + typeof value), 'ERR_INVALID_VALUE');
      }

      return setQueue.add(function () {
        return _maybeDoSet({
          key: key,
          value: value
        }, options.signal);
      });
    },
    replace: function replace(value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!value || value instanceof Uint8Array) {
        throw errCode__default["default"](new Error('Invalid value type: ' + typeof value), 'ERR_INVALID_VALUE');
      }

      return setQueue.add(function () {
        return _maybeDoSet({
          key: undefined,
          value: value
        }, options.signal);
      });
    },
    exists: function exists() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", level.hasWithFallback(configKey, store.has.bind(store), store));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
  return configStore;

  function _maybeDoSet(_x, _x2) {
    return _maybeDoSet2.apply(this, arguments);
  }

  function _maybeDoSet2() {
    _maybeDoSet2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(m, signal) {
      var key, value, _config;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(signal && signal.aborted)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              key = m.key;
              value = m.value;

              if (!key) {
                _context4.next = 10;
                break;
              }

              _context4.next = 7;
              return configStore.getAll();

            case 7:
              _config = _context4.sent;

              if (typeof _config === 'object' && _config !== null) {
                _set__default["default"](_config, key, value);
              }

              return _context4.abrupt("return", _saveAll(_config));

            case 10:
              return _context4.abrupt("return", _saveAll(value));

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _maybeDoSet2.apply(this, arguments);
  }

  function _saveAll(config) {
    var buf = fromString.fromString(JSON.stringify(config, null, 2));
    return store.put(configKey, buf);
  }
}

exports.config = config;